import { createIcon } from './create-icon';

export const ChevronRightIcon = createIcon('ChevronRightIcon', <path d="M9 18l6-6-6-6" />);
